import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import styles from './ServerError.module.css';
export default function ServerError() {
    var t = useTranslation().t;
    return (_jsxs("section", { className: "fadeIn ".concat(styles.container), children: [_jsx("h1", { className: styles.title, children: t('error.server-under-maintenance') }), _jsx("p", { className: styles.description, children: t('error.server-under-maintenance-description') })] }));
}
